// API paths for CR Consolidation Report (tạm dùng chung project-corporate-reports)
export const CONSOLIDATION_API = {
  accessLink: 'project-corporate-reports',
  data: 'project-corporate-reports',
};
